import { LanguageSelector, RegionCheckerBar, RegionChange } from '@/modules/localization';

if (document.getElementById('LanguageSelector')) {
    new LanguageSelector(document.getElementById('LanguageSelector'));
}

if (document.querySelector('.js-region-checker-bar')) {
    new RegionCheckerBar(document.querySelector('.js-region-checker-bar'));
}

if (document.getElementById('RegionChange') && document.getElementById('RegionCurrent')) {
    new RegionChange(document.getElementById('RegionChange'), document.getElementById('RegionCurrent'));
}
